var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "#F7F8F9",
    stroke: "#ABAAC2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.24 5.333c.88 0 1.592.25 2.134.747.542.498.813 1.165.813 2 0 .934-.289 1.627-.866 2.08-.578.445-1.36.667-2.347.667l-.04 1.267H8.881l-.054-2.107h.387c.88 0 1.569-.133 2.067-.4.497-.267.746-.77.746-1.507 0-.533-.16-.955-.48-1.266-.32-.312-.75-.467-1.293-.467-.551 0-.987.15-1.307.453-.31.293-.466.698-.466 1.214H7.334c0-.534.12-1 .36-1.4.24-.41.578-.725 1.013-.947.445-.222.956-.333 1.534-.333Zm-.84 9.494a.798.798 0 0 1-.586-.24.798.798 0 0 1-.24-.587c0-.23.08-.427.24-.586.16-.16.356-.24.587-.24a.74.74 0 0 1 .56.24c.16.16.24.355.24.586 0 .231-.08.427-.24.587a.74.74 0 0 1-.56.24Z",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/questionMark.9006ecc00cec722dbebd425b477e5dea.svg";
export { ForwardRef as ReactComponent };